"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cottagesDeposits = void 0;
const termsConditionsTitle = 'Low deposit';
exports.cottagesDeposits = [
    {
        accommodationTypes: ['cottages'],
        amount: 25,
        unitType: 'percentage',
        termsConditionsContent: `
# Booking Conditions

__Cottages.com is a trading name of Awaze Vacation Rentals Ltd.__

We have made it easier for customers to access the terms on which they have made a
booking. Booking conditions apply as at the time when a booking is made.

For bookings made between 8 August 2018 and 4 November 2019 (inc) –
[https://www.awaze.co.uk/assets/cottages.com_terms_8Aug2018to4Nov2019.pdf](https://www.awaze.co.uk/assets/cottages.com_terms_8Aug2018to4Nov2019.pdf)

For bookings made between 5 November 2019 and 1 February 2020 (inc) –
[https://www.awaze.co.uk/assets/cottages.com_terms_5Nov2019to1Feb2020.pdf](https://www.awaze.co.uk/assets/cottages.com_terms_5Nov2019to1Feb2020.pdf)

For bookings made between 2 February 2020 and 27 February 2020 (inc) –
[https://www.awaze.co.uk/assets/cottages.com_terms_2Feb2020to27Feb2020.pdf](https://www.awaze.co.uk/assets/cottages.com_terms_2Feb2020to27Feb2020.pdf)

For bookings made from 28 February 2020 to 18 May 2020 (inc) –
[https://www.awaze.co.uk/assets/cottages.com_terms_28Feb2020to_18May2020.pdf](https://www.awaze.co.uk/assets/cottages.com_terms_28Feb2020to_18May2020.pdf)

For bookings made from 19 May 2020 to 28 July 2020 (inc) –
[https://www.awaze.co.uk/assets/cottages.com_terms19May2020to28July2020.pdf](https://www.awaze.co.uk/assets/cottages.com_terms19May2020to28July2020.pdf)

For bookings made from 29 July 2020 to 29 December 2020 (inc) –
[https://www.awaze.co.uk/assets/cottages.com_terms_29July2020to29Dec2020.pdf](https://www.awaze.co.uk/assets/cottages.com_terms_29July2020to29Dec2020.pdf)

For bookings made from 30 December 2020 to current date –
[https://www.awaze.co.uk/assets/cottages.com_terms_current.pdf](https://www.awaze.co.uk/assets/cottages.com_terms_current.pdf)
`,
        termsConditionsTitle,
        rules: {
            bookingStartDateMin: new Date('2021-12-17'),
            bookingStartDateMax: new Date('2050-12-31'),
            bookingLeadTimeMin: 70,
            propertySleepsMin: 10,
            propertySleepsMax: 100,
            bookingPriceMin: 0,
            bookingPriceMax: Number.MAX_VALUE,
        },
    },
    {
        accommodationTypes: ['cottages'],
        amount: 25,
        unitType: 'price',
        termsConditionsContent: `
## UK Cottages - £25 offer

1. These terms and conditions should be read with the Booking Conditions and insurance information on our website. Especially note clauses 6 (Payment), 7 (Deposit) and 10 (Full customer cancellations - basic) of the Booking Conditions.
2. Offer applies only to new 2023 and 2024 bookings, with arrival dates which are more than 10 weeks after you make your booking and which are booked between 1 February 2023 and 31 December 2023.
3. Offer only available for those properties that participate in the low deposit scheme.
4. This offer may be used in conjunction with any other accommodation offer or discount that is available at the time of booking.
5. Depending on popularity and property availability, this offer may be extended or withdrawn.
### MAKING YOUR BOOKING
1. The low deposit payable under this offer is £25. When you make your booking, in addition to the low deposit payable, you will also have to pay any insurance premiums (if you are taking out insurance with your booking).
2. This offer does not apply to properties that sleep 10 or more.
3. **The difference between the low deposit and the standard deposit shown on website and/or in the Booking Conditions is payable with the balance payment, which we must receive no later than:**

   a) **10 weeks prior to the start of your trip; or**

   b) **at the time of cancellation if you cancel your booking before the balance due date.**

### BOOKING CANCELLATION
1. This balance payment will include all applicable charges as detailed on your booking confirmation, for example any applicable booking fees. If payment is not received in full on time, we can treat your booking as cancelled by you for a non-refundable reason. If this happens, you will be responsible for the difference between the low deposit and the usual deposit, as well as any applicable booking fee and any cancellation charges which may apply (as set out in the Booking Conditions).  For the avoidance of doubt, you will forfeit the insurance premiums (if applicable).
2. This offer may be used in conjunction with any other accommodation offer or discount that is available at the time of booking.
3. Depending on popularity and property availability, this offer may be extended or withdrawn.
`,
        termsConditionsTitle,
        rules: {
            bookingStartDateMin: new Date('2021-12-17'),
            bookingStartDateMax: new Date('2024-12-31'),
            bookingLeadTimeMin: 70,
            propertySleepsMin: 0,
            propertySleepsMax: 9,
            bookingPriceMin: 0,
            bookingPriceMax: Number.MAX_VALUE,
        },
    },
];
//# sourceMappingURL=cottagesDeposits.js.map